import { PropertyBusinessType } from 'models/Properties';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';

/**
 * For Standalone properties the uid used for viewing Booking.com's Quality Score should be from the property itself but
 * for unit-types it should be its Multi-unit parent uid.
 */
const usePropertyUidForQualityScore = () => {
  const { property } = usePropertySettingsInitData();

  if (
    property.businessType === PropertyBusinessType.UNIT_TYPE &&
    'hotelUid' in property
  ) {
    return property.hotelUid;
  }

  return property.uid as string;
};

export default usePropertyUidForQualityScore;
